<template>
<zm-dialog class="zone-detail-dialog" top="8vh" :visible.sync="visible" show-close @close="handleCancel">
  <!--header-->
  <img :src="logo" alt="" class="zone-detail-dialog__logo">
  <h1 class="zone-detail-dialog__title">{{ planCategoryName }}</h1>
  <div class="zone-detail-dialog__price">
    <price-list :plan-category="planCategory === 'bizplus' ? 'zonebizpzvu' : planCategory" :unit-type="planUnitMap.user"/>
  </div>
  <FeatureULForPro v-if="planCategory === 'pro'" :onEssentialAppLearnMore="onEssentialAppLearnMore" :onAICompanionLearnMore="onAICompanionLearnMore" />
  <FeatureULForBiz v-if="planCategory === 'biz'" :onEssentialAppLearnMore="onEssentialAppLearnMore" :onAICompanionLearnMore="onAICompanionLearnMore" :isEnableBizPriceIncrease="isEnableBizPriceIncrease" />
  <FeatureULForBizPlus
    v-if="planCategory === 'bizplus'"
    :onEssentialAppLearnMore="onEssentialAppLearnMore"
    :onAICompanionLearnMore="onAICompanionLearnMore"
    :onVisitorManagementLearnMore="onVisitorManagementLearnMore"
    :showStartingPrice="false"
    :startingPrice="$money(annualPriceNum * 10)"
  />
  <zm-button type="primary" ghost class="zone-detail-dialog__confirm-btn text-capitalize" @click="handleSure">{{ $t('billing.zone.see_full_feature') }}</zm-button>
  <p class="zone-detail-dialog__tips" v-if="['biz', 'bizplus'].includes(planCategory)">
    *{{ $t('billing.zone.biz_details.tips', [$money(annualPriceNum * 10, { forceDiff: true })]) }}
  </p>
</zm-dialog>
</template>
<script type="text/jsx">
import ZoomOneLogo from '@/assets/plans/zoom_one.svg';
import ZoomWorkplaceLogo from '@/assets/plans/zoom_workplace.svg';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import EssentialAppLearnMoreDialog from '@/components/app-bundle-learn-more-dialog.vue';
import { mapState, mapGetters } from 'vuex';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import { getCategoryNameI18nKey } from '../common/utils';
import {getCurrency, getCurrencySymbol} from "@/utils/currency";
import AICompanionLearnMoreDialog from '@/components/full-comparison-table/ai-companion-learn-more-dialog.vue';
import VisitorManagementLearnMoreDialog from '@/components/full-comparison-table/visitor-management-learn-more-dialog.vue';
import SparklesIcon from '@/assets/plans/sparkles.png'
import { plansof } from '@/utils/chain';
import PriceList from "@/components/price-list.vue";
import { planUnitMap } from '@/common/product-unit';

const FeatureULForPro = {
  props: {
    onEssentialAppLearnMore: Function,
    onAICompanionLearnMore: Function,
  },
  render() {
    return (
      <ul class="zone-detail-dialog__feature">
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{this.$t('billing.zone.meetings')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.pro_details.row1')}</li>
            <li>{this.$t('billing.zone.pro_details.row2')}</li>
            <li>{this.$t('billing.zone.pro_details.row3')}</li>
            <li>{this.$t('billing.zone.pro_details.row4')}</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{this.$t('billing.whiteboard')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.pro_details.row5')}</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{this.$t('billing.team_chat')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.pro_details.row6')}</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">
            {this.$t('billing.mail_calendar')}
          </h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.biz_details.mail_calendar.row1')}</li>
          </ul>
        </li>
        {
          !window.newBillingConfig.disabledClips && (
            <li class="zone-detail-dialog__feature-item">
              <h2 class="zone-detail-dialog__feature-title first-capitalize">
                <span class="zone-detail-dialog__new-label">{this.$t('billing.common.new')}</span>
                { this.$t('billing.clips_plus') }
              </h2>
              <ul class="zone-detail-dialog__feature-item-list">
                <li>{ this.$t('billing.zone.biz_details.clips.row1') }</li>
                <li>{ this.$t('billing.zone.biz_details.clips.row2') }</li>
              </ul>
            </li>
          )
        }
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">
            <span class="zone-detail-dialog__new-label">{this.$t('billing.common.new')}</span>
            { this.$t('billing.notes') }
          </h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{ this.$t('billing.zone.biz_details.notes.row1') }</li>
            <li>{ this.$t('billing.zone.biz_details.notes.row2') }</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item ai-companion-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">
            <span class="zone-detail-dialog__new-label">{this.$t('billing.common.new')}</span>
            { this.$t('billing.ai_companion') }
            <img src={SparklesIcon} class="zone-detail-dialog__feature-title__icon" />
          </h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{ this.$t('billing.zone.biz_details.ai_companion.row1') }</li>
            <li>
              { this.$t('billing.zone.biz_details.ai_companion.row2') }<br/>
              <zm-button type="link" class="zone-detail-dialog__link" onClick={this.onAICompanionLearnMore} aria-label="Learn More about AI Companion">{this.$t('billing.common.learn_more')}</zm-button>
            </li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{this.$t('billing.essential_apps')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.pro_details.row8')}</li>
            <li>
              {this.$t('billing.zone.pro_details.row9')}<br/>
              <zm-button type="link" class="zone-detail-dialog__link" onClick={this.onEssentialAppLearnMore} aria-label="Learn More about Essential Apps">{this.$t('billing.common.learn_more')}</zm-button>
            </li>
          </ul>
        </li>
      </ul>
    )
  },
};

const FeatureULForBiz = {
  props: {
    onEssentialAppLearnMore: Function,
    onAICompanionLearnMore: Function,
    isEnableBizPriceIncrease: Boolean
  },
  render() {
    return (
      <ul class="zone-detail-dialog__feature">
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{this.$t('billing.zone.meetings')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.biz_details.meetings.row1')}</li>
            <li>{this.$t('billing.zone.biz_details.meetings.row2')}</li>
            <li>{this.$t('billing.zone.biz_details.meetings.row3')}</li>
            <li>{this.$t('billing.zone.biz_details.meetings.row4')}</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{this.$t('billing.whiteboard')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.biz_details.whiteboard.row1')}</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{this.$t('billing.team_chat')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.biz_details.team_chat.row1')}</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">
            {/* <span class="zone-detail-dialog__new-label">{this.$t('billing.common.beta')}</span> */}
            {this.$t('billing.mail_calendar')}
          </h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.biz_details.mail_calendar.row1')}</li>
          </ul>
        </li>
        {
          !window.newBillingConfig.disabledClips && (
            <li class="zone-detail-dialog__feature-item">
              <h2 class="zone-detail-dialog__feature-title first-capitalize">
                <span class="zone-detail-dialog__new-label">{this.$t('billing.common.new')}</span>
                { this.$t('billing.clips_plus') }
              </h2>
              <ul class="zone-detail-dialog__feature-item-list">
                <li>{ this.$t('billing.zone.biz_details.clips.row1') }</li>
                <li>{ this.$t('billing.zone.biz_details.clips.row2') }</li>
              </ul>
            </li>
          )
        }
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">
            <span class="zone-detail-dialog__new-label">{this.$t('billing.common.new')}</span>
            { this.$t('billing.notes') }
          </h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{ this.$t('billing.zone.biz_details.notes.row1') }</li>
            <li>{ this.$t('billing.zone.biz_details.notes.row2') }</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item ai-companion-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">
            <span class="zone-detail-dialog__new-label">{this.$t('billing.common.new')}</span>
            { this.$t('billing.ai_companion') }
            <img src={SparklesIcon} class="zone-detail-dialog__feature-title__icon" />
          </h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{ this.$t('billing.zone.biz_details.ai_companion.row1') }</li>
            <li>
              { this.$t('billing.zone.biz_details.ai_companion.row2') }<br/>
              <zm-button type="link" class="zone-detail-dialog__link" onClick={this.onAICompanionLearnMore} aria-label="Learn More about AI Companion">{this.$t('billing.common.learn_more')}</zm-button>
            </li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">
            {/* <span class="zone-detail-dialog__new-label">{this.$t('billing.common.new')}</span> */}
            {this.$t('billing.essential_apps')}
          </h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.biz_details.essential_apps.row1')}</li>
            <li>
              {this.$t('billing.zone.biz_details.essential_apps.row2')}<br/>
              <zm-button type="link" class="zone-detail-dialog__link" onClick={this.onEssentialAppLearnMore} aria-label="Learn More about Essential Apps">{this.$t('billing.common.learn_more')}</zm-button>
            </li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{this.$t('billing.extras')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.zone.biz_details.extras.row1')}</li>
            <li>{this.$t('billing.zone.biz_details.extras.row2')}</li>
            <li>{this.$t('billing.zone.biz_details.extras.row3')}</li>
          </ul>
        </li>
        {!!this.isEnableBizPriceIncrease && (<li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">
            <span class="zone-detail-dialog__new-label">{this.$t('billing.common.new')}</span>
            {this.$t('billing.scheduler.short_title')}
          </h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{this.$t('billing.scheduler.feature_details.item1')}</li>
            <li>{this.$t('billing.scheduler.feature_details.item2')}</li>
          </ul>
        </li>)}
      </ul>
    )
  },
}

export default {
  name: 'PlanDetails',
  mixins: [ConfirmComponent],
  components: {
    PriceList,
    FeatureULForBiz,
    FeatureULForPro,
  },
  props: {
    planCategory: String,
  },
  data() {
    return {
      visible: false,
      currencySymbol: getCurrencySymbol(getCurrency()),
      essentialAppLearnMoreDialogService: new ServiceConfirm(EssentialAppLearnMoreDialog, this.$store),
      aiCompanionLearnMoreDialogService: new ServiceConfirm(AICompanionLearnMoreDialog),
      visitorManagementLearnMoreDialogService: new ServiceConfirm(VisitorManagementLearnMoreDialog),
      planUnitMap
    };
  },
  methods: {
    async onEssentialAppLearnMore () {
      this.$tracking.buyInteraction('product details', 'plan details - learn more');
      await this.essentialAppLearnMoreDialogService.confirm();
    },
    async onAICompanionLearnMore() {
      this.$tracking.buyInteraction('product details', 'plan details - learn more');
      await this.aiCompanionLearnMoreDialogService.confirm();
    },
    async onVisitorManagementLearnMore() {
      this.$tracking.buyInteraction('product details', 'plan details - learn more');
      await this.visitorManagementLearnMoreDialogService.confirm();
    },
    handleSure() {
      this.$tracking.buyInteraction('product details', 'plan details - see full feature list');
    },
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters(['enableBizPriceIncrease']),
    isEnableBizPriceIncrease() {
      return this.enableBizPriceIncrease;
    },
    logo() {
      return window.newBillingConfig.isZoomWorkplaceRebranding ? ZoomWorkplaceLogo : ZoomOneLogo;
    },
    annualPriceNum () {
      if(this.planCategory === 'bizplus'){
        const zoneBundlePlans = plansof(this.planMapFlat).type(planTypes.ZOOM_ONE_BUNDLE).annual();
        const category0 = zoneBundlePlans.clone().get(0)?.category; // HACK only get first of regions
        return zoneBundlePlans.category(category0).sum('price');
      };
      let annualPlan = this.planMapFlat.find(plan => plan.category === this.planCategory && plan.billing_cycle === BILLING_CYCLE.ANNUAL);
      if (annualPlan) {
        return annualPlan.amount;
      }
      return 0;
    },
    annualPrice () {
      return (this.annualPriceNum / 100).toFixed(2);
    },
    monthlyPriceNum () {
      if(this.planCategory === 'bizplus'){
        const zoneBundlePlans = plansof(this.planMapFlat).type(planTypes.ZOOM_ONE_BUNDLE).monthly();
        const category0 = zoneBundlePlans.clone().get(0)?.category; // HACK only get first of regions
        return zoneBundlePlans.category(category0).sum('price')
      };
      let monthlyPlan = this.planMapFlat.find(plan => plan.category === this.planCategory && plan.billing_cycle === BILLING_CYCLE.MONTHLY);
      if (monthlyPlan) {
        return monthlyPlan.amount;
      }
      return 0;
    },
    monthlyPrice () {
      return (this.monthlyPriceNum / 100).toFixed(2);
    },
    planCategoryName() {
      return this.$t(getCategoryNameI18nKey(this.planCategory));
    },
  },
}
</script>
<style lang="scss">
@import '@/styles/_variables.scss';
@import '@/styles/responsive.scss';

.zone-detail-dialog {
  .zm-dialog {
    min-width: 522px;
    padding: 70px 60px;
    width: fit-content;
  }
  &__title {
    font-style: normal;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 22px;
    line-height: 150%;
    color: #515079;
  }
  &__price {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-bottom: 12px;
    @include media(mobile, tablet) {
      margin-bottom: 0;
      padding: 16px 0;
    }

    p.price.price-component {
      // Higher priority selector to overwrite the default style
      flex-wrap: nowrap;
      @include media(mobile, tablet) {
        flex-wrap: wrap;
      }
    }

    &-item {
      flex: 1;
      padding-right: 24px;
      padding-left: 0;
      display: flex;
      align-items: flex-start;

      .price__currency {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 36px;
        color: #00053D;
        margin-right: 2px;
      }
      .price__int {
        font-family: $happy-display;
        font-style: normal;
        font-weight: 400;
        font-size: 32px;
        line-height: 48px;
        color: #00053D;
        margin-right: 2px;
      }
      .price__decimal {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 36px;
        color: #00053D;
        margin-right: 2px;
      }
      .price__unit {
        font-style: normal;
        font-weight: 450;
        font-size: 16px;
        line-height: 38px;
        color: #00053D;
        align-self: flex-end;
      }
      &+& {
        padding-right: 0;
        padding-left: 24px;
        border-left: 2px solid #B8B8C4;
      }
    }

  }
  &__feature {
    &-title {
      color: #00053D;
      font-family: Almaden Sans;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%; /* 21px */
      letter-spacing: 0.14px;
      display: flex;
      flex-direction: row;
      align-items: center;
      &__icon {
        width: 16px;
        height: 16px;
        font-size: 0;
        margin-left: 4px;
      }
    }
    &-item {
      position: relative;
      padding-left: 20px;
      margin-bottom: 16px;
      &::before {
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        background-image: url('../../../assets/Vector.svg');
        background-repeat: no-repeat;
        background-size: cover;
        width: 16px;
        height: 21px;
        font-size: 20px;
        font-weight: 700;
      }
      &-list {
        list-style: disc;
        padding-left: 14px;
        li {
          &::marker {
            color: #00053D;
          }
          &::first-letter {
            text-transform: capitalize;
          }
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          line-height: 150%;
          color: #00053D;
        }
      }
    }
  }
  &__link.zm-button--link {
    font-style: normal;
    font-weight: 450;
    font-size: 12px;
    line-height: 150%;
    padding: 0;
  }
  &__confirm-btn {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 120%;
    color: #0B5CFF;
    padding: 0;
  }
  &__new-label {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    text-transform: uppercase;
    color: #0B5CFF;
    background: #F2F2F4;
    border-radius: 4px;
    padding: 0 6px;
    margin-right: 4px;
  }
  &__tips {
    margin: 0;
    margin-top: 16px;
    padding: 8px 12px;
    background: #F2F2F4;
    border-radius: 8px;
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    color: #515079;
  }
}
</style>
